import React, { useState } from "react";

import store from "store";
import * as api from "core-module/services/api";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Wizard from "common/components/Wizard/Wizard.jsx";

import SweetAlert from "react-bootstrap-sweetalert";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...buttonStyle
};

class Step1 extends React.Component {
  sendState() {
    return this.state;
  }
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            Summary text (include actual data cap and after pack cap ?)
          </h4>
        </GridItem>
      </GridContainer>
    );
  }
}

class Step2 extends React.Component {
  sendState() {
    return this.state;
  }
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>Billing text</h4>
        </GridItem>
      </GridContainer>
    );
  }
}

const TrafficPackWizardStep1 = withStyles(style)(Step1);
const TrafficPackWizardStep2 = withStyles(style)(Step2);

const TrafficPackWizard = props => {
  const { classes } = props;
  const [alert, setAlert] = useState(null);

  const onClickFinish = () => {
    const handleConfirm = async () => {
      const userid = store.getState().services.ids.user;

      await api.postNload(
        `user.${userid}/trafficpack`,
        {},
        0,
        `user.${userid}/currentbroadband`,
        `user.${userid}/broadbandtraffic`
      );

      setAlert(
        <SweetAlert
          success
          style={{
            display: "block",
            top: "5%",
            maxWidth: "90%",
            marginTop: "1%"
          }}
          title="Success"
          onConfirm={() => {
            setAlert(null);
            props.onFinishWizard();
          }}
          onCancel={() => {
            setAlert(null);
            props.onFinishWizard();
          }}
          confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {"Traffic pack added!"}
        </SweetAlert>
      );
    };

    setAlert(
      <SweetAlert
        info
        style={{
          display: "block",
          top: "5%",
          maxWidth: "90%",
          marginTop: "1%"
        }}
        title="Add Traffic Pack"
        onConfirm={handleConfirm}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={props.classes.button + " " + props.classes.success}
        cancelBtnCssClass={props.classes.button + " " + props.classes.warning}
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
        showCancel
      >
        Traffic pack confirm text
      </SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      <GridContainer justify="center">
        <GridItem xs={12} md={8}>
          <Wizard
            color="primary"
            steps={[
              {
                stepName: "Summary",
                stepComponent: TrafficPackWizardStep1,
                stepId: "summary2"
              },
              {
                stepName: "Billing",
                stepComponent: TrafficPackWizardStep2,
                stepId: "billing2"
              }
            ]}
            title="Traffic Pack Wizard"
            subtitle=""
            finishButtonClick={onClickFinish}
            cancelButtonClick={props.onFinishWizard}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(style)(TrafficPackWizard);
